export const orderType = {
    SALE: 0,
    REFUND_CLIENT: 1,
    REFUND_ORGANIZATION: 2,
    EXCHANGE_ORGANIZATION: 3,
    EXCHANGE_CLIENT: 4,
    RESERVATION: 5,
    RENEWAL: 6,
    OPTION: 7,
    RESERVATION_FREEING: 8,
    OPTION_FREEING: 9,
    ST_TRANSFER: 10
};
